import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import deepMerge from '../../utils/deepMerge';
import engagement from './engagement';
import settings from './settings';
import project from './project';
import core from './core';
import apps from './apps';
/**
 * Data type definitions.
 * Additional types might be added by passing `dataTypes` to `EcrionProvider`
 * and will be merged with this object.
 * @type {import('./types').DataTypesConfig}
 */

var TYPES = {};
/** Get the name of the supported data types */

export var getDataTypes = function getDataTypes() {
  return Object.keys(TYPES);
};
/** Get the name of the required data prop */

export var getRequiredDataProps = function getRequiredDataProps(dataType) {
  var deps = [];

  if (dataType === 'promotionAd') {
    deps.push({
      name: 'promotionId',
      dataType: 'promotion'
    });
  } else if (dataType === 'promotionJob') {
    deps.push({
      name: 'promotionId',
      dataType: 'promotion'
    });
  } else if (dataType === 'promotionAdContent') {
    deps.push({
      name: 'promotionId',
      dataType: 'promotion'
    });
    deps.push({
      name: 'adId',
      dataType: 'promotionAd'
    });
  } else if (dataType === 'projectDependency') {
    deps.push({
      name: 'projectName',
      dataType: 'project'
    });
  } else if (dataType === 'projectTemplate') {
    deps.push({
      name: 'projectId',
      dataType: 'project'
    });
  } else if (dataType === 'repository') {
    deps.push({
      name: 'workspace',
      dataType: 'workspace'
    });
    deps.push({
      name: 'path'
    });
  } else if (dataType === 'engagement') {
    deps.push({
      name: 'journeyId',
      dataType: 'journey'
    });
    deps.push({
      name: 'stageId',
      dataType: 'journeyStage'
    });
    deps.push({
      name: 'touchpointId',
      dataType: 'journeyTouchpoint'
    });
  } else if (dataType === 'engagementProject') {
    deps.push({
      name: 'journeyId',
      dataType: 'journey'
    });
  } else if (dataType === 'interaction') {
    deps.push({
      name: 'journeyId',
      dataType: 'journey'
    });
  } else if (dataType === 'communicationOutput') {
    deps.push({
      name: 'communication'
    });
    deps.push({
      name: 'jobId'
    });
  }

  return deps;
};
/** Gets the config of the dataType
 * @param {string} dataType
 */

export var getDataType = function getDataType(dataType) {
  if (!TYPES[dataType]) {
    // eslint-disable-next-line no-console
    console.error(dataType + ' data type not recognized. Maybe you forgot to export the data type configuration?');
  }

  return TYPES[dataType];
};
/** Adds new data type or overwrites existing ones
 * @param {import('./types').DataTypesConfig} dataTypes
 */

export var addDataType = function addDataType(dataTypes) {
  var _loop = function _loop(dataTypeName) {
    var userDataType = dataTypes[dataTypeName];
    var builtInDataType = {};
    if (TYPES[dataTypeName]) builtInDataType = TYPES[dataTypeName];else if (userDataType.extends) builtInDataType = TYPES[userDataType.extends];
    /**@type {import('./types').DataType<any>} */

    var dataType = deepMerge(builtInDataType, userDataType); //merge arrays: columns, contextMenu

    if (userDataType.columns && builtInDataType.columns) {
      dataType.columns = userDataType.columns.map(function (userColumn) {
        if (!userColumn.id) throw new Error('An id is required for a column definition');
        var builtInColumn = builtInDataType.columns.find(function (c) {
          return c.id === userColumn.id;
        });
        return _objectSpread({}, builtInColumn, userColumn);
      });
    }

    TYPES[dataTypeName] = dataType;
  };

  for (var dataTypeName in dataTypes) {
    _loop(dataTypeName);
  }
};

var init = function init() {
  var allTypes = _objectSpread({}, core, settings, project, engagement, apps); //resolve extends

  /**@type {import('./types').DataTypesConfig} */


  var extendedTypes = {};
  Object.keys(allTypes).forEach(function (type) {
    if (allTypes[type].extends) extendedTypes[type] = allTypes[type];else TYPES[type] = allTypes[type];
  });
  addDataType(extendedTypes);
};

init();
export default TYPES;